<template>
  <PageVC>
    <nav class="restaurants__restaurant-nav">
      <HUISlider
        :initialSlide="indexOfInitialSlide"
        v-if="restaurants && typeof indexOfInitialSlide === 'number'"
      >
        <router-link
          replace
          active-class="restaurants__restaurant-nav-link--active"
          class="restaurants__restaurant-nav-link"
          v-for="restaurant in restaurants"
          :key="'restaurant-nav-' + restaurant.id"
          :to="{ name: routes.RESTAURANT, params: { restaurantSlug: restaurant.slug } }"
        >{{ restaurant.name }}</router-link>
      </HUISlider>
    </nav>
    <router-view ref="router-view"></router-view>
  </PageVC>
</template>

<script>
import { mapState } from 'vuex'
import { HUISlider } from '@/halifax-ui'
import PageVC from '@/containers/PageVC'
import routes from '@/router/routes'

export default {
  components: {
    PageVC,
    HUISlider
  },
  data() {
    return {
      routes,
      indexOfInitialSlide: null
    }
  },
  watch: {
    restaurants() {
      this.indexOfInitialSlide = this.computeIndexOfInitialSlide()
    }
  },
  created() {
    this.indexOfInitialSlide = this.restaurants ? this.computeIndexOfInitialSlide() : null
  },
  computed: {
    ...mapState('restaurant', {
      restaurants: 'restaurants'
    })
  },
  methods: {
    afterEnter() {
      if (typeof this.$refs['router-view'].afterEnter === 'function') {
        this.$refs['router-view'].afterEnter()
      }
    },
    computeIndexOfInitialSlide() {
      return this.restaurants
        .map(restaurant => restaurant.slug)
        .indexOf(this.$route.params.restaurantSlug)
    }
  }
}
</script>

<style lang="scss">
@import '~@/halifax-ui/src/scss/framework';
@import '~@/scss/variables';

.restaurants {
  &__restaurant-nav {
    height: $height-navbar;
    background-color: $text-color;
    margin-top: -$padding-top-page-vc;
  }
  &__restaurant-nav-link {
    color: #888a80;
    text-decoration: none;
    font-weight: 700;
    font-size: 1.4rem;
    line-height: $height-navbar;
    margin: 0 10px;

    &:first-of-type {
      margin-left: 15px;
    }
    &:last-of-type {
      margin-right: 15px;
    }
    &--active {
      color: #fff;
    }
  }
}
</style>
